export default {
  props: {
    leftItems: {
      // 左侧列
      type: Array,
      required: true
    },
    rightItems: {
      type: Array,
      required: true
    },
    img: {
      type: String,
      default: require('@/assets/images/advantages-icon.png')
    }
  },
  data() {
    return {
      leftList: this.leftItems,
      rightList: this.rightItems,
      styleLeft: {
        transform: 'scaleX(-1)'
      }
    };
  }
};